import React from 'react';
import { Button } from './Button';
export const HeroSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS';
  return <section className="bg-gradient-to-b from-teal-900 to-teal-800 text-white py-16" data-id="element-211">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-212">
        <h1 className="flex flex-col gap-4 mb-8" data-id="element-213">
          <span className="text-3xl md:text-4xl font-bold text-center leading-tight" data-id="element-214">
            You're Not Broken, Your Nervous System Is Just Stuck In
            Fight-Flight-Freeze.
          </span>
          <span className="text-2xl md:text-3xl font-medium text-center leading-tight bg-teal-800/50 py-2 px-4 rounded-lg italic" data-id="element-215">
            This 30-Day Program Shows You How to Gently Reset It.
          </span>
        </h1>
        <div className="mb-12 max-w-3xl mx-auto" data-id="element-216">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rqsGRvYQUSkg6a2cYoVRBa/Orange_And_Red_Modern_Minimalist_The_Most_Attractive_YouTube_Banner_%287%29.png" alt="Hero illustration" className="w-full rounded-lg shadow-xl" data-id="element-217" />
        </div>
        <div className="mb-10 text-lg space-y-4" data-id="element-218">
          <p data-id="element-219">If you already understand that trauma lives in the body...</p>
          <p data-id="element-220">
            If you've read The Body Keeps the Score, followed Irene Lyon, or
            practiced somatic tools...
          </p>
          <p data-id="element-221">If you're tired of therapy that keeps you stuck in your head...</p>
          <p data-id="element-222">Then you're not early in your healing journey.</p>
          <p className="font-bold" data-id="element-223">You're just under-supported.</p>
        </div>
        <div className="flex justify-center" data-id="element-224">
          <Button link={checkoutUrl} data-id="element-225">Start My Reset – Just $29 ➔</Button>
        </div>
      </div>
    </section>;
};